import { Fragment, NodeType, Slice } from 'prosemirror-model'
import { Command } from 'common/Prose/Commands/types'
import { ReplaceAroundStep } from 'prosemirror-transform'

export function sinkListItem(itemType: NodeType): Command {
  return function (state, dispatch) {
    const { $from, $to } = state.selection
    const range = $from.blockRange(
      $to,
      (node) => node.childCount > 0 && !!node.firstChild && node.firstChild.type === itemType,
    )
    if (!range) return false
    const startIndex = range.startIndex
    if (startIndex === 0) return false
    const parent = range.parent
    const nodeBefore = parent.child(startIndex - 1)
    if (nodeBefore.type !== itemType) return false

    if (dispatch) {
      const nestedBefore = nodeBefore.lastChild && nodeBefore.lastChild.type === parent.type
      const inner = nestedBefore ? Fragment.from(itemType.create()) : Fragment.empty
      const slice = new Slice(
        Fragment.from(itemType.create(null, Fragment.from(state.schema.nodes.bullet_list.create(null, inner)))),
        nestedBefore ? 3 : 1,
        0,
      )
      const before = range.start
      const after = range.end
      dispatch(
        state.tr
          .step(new ReplaceAroundStep(before - (nestedBefore ? 3 : 1), after, before, after, slice, 1, true))
          .scrollIntoView(),
      )
    }
    return true
  }
}
